
export const placementDrives = [
  {
    id: 1,
    date: "11-08-2026",
    company: "Prodhee Technologies Pvt. Ltd.",
    role: "Dhee Coding Lab, INCUBATION INTERNSHIP PROGRAM (IIP)",
    mode: "Offline",
    type: "Internship",
    package: "—",
    target: "2023-2027 Batch",
    enrolled: 67,
    selected: 6,
  },
  {
    id: 2,
    date: "20-08-2026",
    company: "Global Quest Technologies",
    role: "CSR Scholarship Drive (2.0)",
    mode: "Offline",
    type: "Internship",
    package: "2.5 LPA",
    target: "2023-2027 Batch",
    enrolled: 106,
    selected: 10,
  },
  {
    id: 3,
    date: "21-08-2026",
    company: "QSpiders",
    role: "Java Full Stack with React / Python with Data Analytics",
    mode: "Offline",
    type: "Internship & Placement",
    package: "3 LPA - 9.5 LPA",
    target: "BE/BTech/BSc/BCA/MSc/MCA",
    enrolled: 78,
    selected: 28,
  },
  {
    id: 4,
    date: "03-09-2026",
    company: "VStand4U Technologies",
    role: "AI Workshop & Exclusive CSR Placement Drive",
    mode: "Offline",
    type: "Internship",
    package: "—",
    target: "2023-2027 Batch",
    enrolled: 84,
    selected: 4,
  },
  
{
  id: 5,
  date: "07-10-2026",
  company: "TAP Academy",
  role: "Campus-to-Corporate Internship Placement Drive",
  mode: "Offline",
  type: "Internship & Placement",
  package: "Not specified",
  target: "2027 Passing-Out Batch - All Branches",
  enrolled: 11,
  selected: 11,
},

];

export const selectedCandidates = [
  // Dhee Coding Lab - 6 students
  {
    id: 1,
    hallTicket: "23RU1A0580",
    studentName: "PUJARI LAKSHMI LOKESH",
    department: "University College of Engineering",
    date: "11-08-2026",
    company: "Dhee Coding Lab, INCUBATION INTERNSHIP PROGRAM (IIP)",
    selectedCount: 6,
  },
  {
    id: 2,
    hallTicket: "23RU1A0576",
    studentName: "PINJARI ZUBEDA",
    department: "University College of Engineering",
    date: "",
    company: "",
    selectedCount: null,
  },
  {
    id: 3,
    hallTicket: "23RU1A05A6",
    studentName: "YADAMALA HEMALATHA",
    department: "University College of Engineering",
    date: "",
    company: "",
    selectedCount: null,
  },
  {
    id: 4,
    hallTicket: "24RU5A0602",
    studentName: "C. SRAVANI",
    department: "University College of Engineering",
    date: "",
    company: "",
    selectedCount: null,
  },
  {
    id: 5,
    hallTicket: "24RU5A0401",
    studentName: "ANTHIMENI JYOTSHNA",
    department: "University College of Engineering",
    date: "",
    company: "",
    selectedCount: null,
  },
  {
    id: 6,
    hallTicket: "24RU5A0405",
    studentName: "C.V. HARSHITHA",
    department: "University College of Engineering",
    date: "",
    company: "",
    selectedCount: null,
  },

  // Global Quest Technologies - 10 students
  {
    id: 7,
    hallTicket: "23RU5A0602",
    studentName: "C. SRAVANI",
    department: "University College of Engineering",
    date: "20-08-2026",
    company: "Global Quest Technologies",
    selectedCount: 10,
  },
  {
    id: 8,
    hallTicket: "24RU5A0510",
    studentName: "PALLE SUNANDA",
    department: "University College of Engineering",
    date: "",
    company: "",
    selectedCount: null,
  },
  {
    id: 9,
    hallTicket: "23RU1A0515",
    studentName: "BOGGARAPU NANDINI",
    department: "University College of Engineering",
    date: "",
    company: "",
    selectedCount: null,
  },
  {
    id: 10,
    hallTicket: "23RU1A0528",
    studentName: "EERLA NAGAVENNELA",
    department: "University College of Engineering",
    date: "",
    company: "",
    selectedCount: null,
  },
  {
    id: 11,
    hallTicket: "23RU1A0536",
    studentName: "JYOTHI AKSHAY",
    department: "University College of Engineering",
    date: "",
    company: "",
    selectedCount: null,
  },
  {
    id: 12,
    hallTicket: "23RU1A0576",
    studentName: "PINJARI ZUBEDA",
    department: "University College of Engineering",
    date: "",
    company: "",
    selectedCount: null,
  },
  {
    id: 13,
    hallTicket: "23RU1A0578",
    studentName: "PALLAVI POTHU",
    department: "University College of Engineering",
    date: "",
    company: "",
    selectedCount: null,
  },
  {
    id: 14,
    hallTicket: "23RU1A0580",
    studentName: "P. LAKSHMI LOKESH",
    department: "University College of Engineering",
    date: "",
    company: "",
    selectedCount: null,
  },
  {
    id: 15,
    hallTicket: "23RU1A0586",
    studentName: "SHAIK CARPENTER MOHAMMED REHAN",
    department: "University College of Engineering",
    date: "",
    company: "",
    selectedCount: null,
  },
  {
    id: 16,
    hallTicket: "23RU1A0443",
    studentName: "VADDIMUKKALA AKASH",
    department: "University College of Engineering",
    date: "",
    company: "",
    selectedCount: null,
  },

  // QSpiders - 28 students
  {
    id: 17,
    hallTicket: "23RUA0536",
    studentName: "Jyothi Akshay",
    department: "University College of Engineering",
    date: "21-08-2026",
    company: "QSpiders",
    selectedCount: 28,
  },
  {
    id: 18,
    hallTicket: "23RUA0577",
    studentName: "Pittu Sreevidya",
    department: "University College of Engineering",
    date: "",
    company: "",
    selectedCount: null,
  },
  {
    id: 19,
    hallTicket: "23RUA0527",
    studentName: "Dudekula Jamalbee",
    department: "University College of Engineering",
    date: "",
    company: "",
    selectedCount: null,
  },
  {
    id: 20,
    hallTicket: "23RUA0589",
    studentName: "Sreenivasulu Gari Balaji",
    department: "University College of Engineering",
    date: "",
    company: "",
    selectedCount: null,
  },
  {
    id: 21,
    hallTicket: "23RUA0580",
    studentName: "Pujari Lakshmi Lokesh",
    department: "University College of Engineering",
    date: "",
    company: "",
    selectedCount: null,
  },
  {
    id: 22,
    hallTicket: "23RUA0406",
    studentName: "Balanthri Hansika",
    department: "University College of Engineering",
    date: "",
    company: "",
    selectedCount: null,
  },
  {
    id: 23,
    hallTicket: "24RUSA0401",
    studentName: "Anthimeni Jyothsna",
    department: "University College of Engineering",
    date: "",
    company: "",
    selectedCount: null,
  },
  {
    id: 24,
    hallTicket: "24RUSA0406",
    studentName: "Ganesh Srinivasulu",
    department: "University College of Engineering",
    date: "",
    company: "",
    selectedCount: null,
  },
  {
    id: 25,
    hallTicket: "23RUA0576",
    studentName: "Pinjari Zubeda",
    department: "University College of Engineering",
    date: "",
    company: "",
    selectedCount: null,
  },
  {
    id: 26,
    hallTicket: "23RUA0511",
    studentName: "Bandi Kiran Kumar",
    department: "University College of Engineering",
    date: "",
    company: "",
    selectedCount: null,
  },
  {
    id: 27,
    hallTicket: "24RUSA0606",
    studentName: "Shaik Zabiulla",
    department: "University College of Engineering",
    date: "",
    company: "",
    selectedCount: null,
  },
  {
    id: 28,
    hallTicket: "23RUA0586",
    studentName: "Shaik Carpenter Mohammed Rehan",
    department: "University College of Engineering",
    date: "",
    company: "",
    selectedCount: null,
  },
  {
    id: 29,
    hallTicket: "23RUA0612",
    studentName: "Lingapuram Ashwini",
    department: "University College of Engineering",
    date: "",
    company: "",
    selectedCount: null,
  },
  {
    id: 30,
    hallTicket: "23RUA0608",
    studentName: "Dhathri Kondreddy",
    department: "University College of Engineering",
    date: "",
    company: "",
    selectedCount: null,
  },
  {
    id: 31,
    hallTicket: "23RUA0537",
    studentName: "Kadiri Madhusai",
    department: "University College of Engineering",
    date: "",
    company: "",
    selectedCount: null,
  },
  {
    id: 32,
    hallTicket: "23RUA0593",
    studentName: "Thadakara Madhan Kumar",
    department: "University College of Engineering",
    date: "21-08-2026",
    company: "Qspiders",
    selectedCount: 28,
  },
  {
    id: 33,
    hallTicket: "23RUA0544",
    studentName: "Kummari Lakshman Pradeep",
    department: "University College of Engineering",
    date: "",
    company: "",
    selectedCount: null,
  },
  {
    id: 34,
    hallTicket: "23RUA0592",
    studentName: "Telugu Harshith",
    department: "University College of Engineering",
    date: "",
    company: "",
    selectedCount: null,
  },
  {
    id: 35,
    hallTicket: "23RUA0523",
    studentName: "Challa Sailikhitha",
    department: "University College of Engineering",
    date: "",
    company: "",
    selectedCount: null,
  },
  {
    id: 36,
    hallTicket: "23RUA0528",
    studentName: "Eerla Nagavenneela",
    department: "University College of Engineering",
    date: "",
    company: "",
    selectedCount: null,
  },
  {
    id: 37,
    hallTicket: "24RUSA0402",
    studentName: "A. Sarithakrishna",
    department: "University College of Engineering",
    date: "",
    company: "",
    selectedCount: null,
  },
  {
    id: 38,
    hallTicket: "23RUA0443",
    studentName: "Vaddimukkala Aakash",
    department: "University College of Engineering",
    date: "",
    company: "",
    selectedCount: null,
  },
  {
    id: 39,
    hallTicket: "23RUA0614",
    studentName: "Harinivas Mandla",
    department: "University College of Engineering",
    date: "",
    company: "",
    selectedCount: null,
  },
  {
    id: 40,
    hallTicket: "24RUSA0603",
    studentName: "Mahesh Damam",
    department: "University College of Engineering",
    date: "",
    company: "",
    selectedCount: null,
  },
  {
    id: 41,
    hallTicket: "24RUSA0103",
    studentName: "Devarinti Bhavani",
    department: "University College of Engineering",
    date: "",
    company: "",
    selectedCount: null,
  },
  {
    id: 42,
    hallTicket: "24RUSA0405",
    studentName: "C.V. Harshitha",
    department: "University College of Engineering",
    date: "",
    company: "",
    selectedCount: null,
  },
  {
    id: 43,
    hallTicket: "24RUSA0403",
    studentName: "Priya Ragini",
    department: "University College of Engineering",
    date: "",
    company: "",
    selectedCount: null,
  },
  {
    id: 44,
    hallTicket: "23RUA0583",
    studentName: "Shaik Afrid",
    department: "University College of Engineering",
    date: "",
    company: "",
    selectedCount: null,
  },

  // VStand4U Technologies - 4 students
  {
    id: 45,
    hallTicket: "23RU1A0516",
    studentName: "B. Praveen Kumar",
    department: "University College of Engineering",
    date: "03-09-2026",
    company: "VStand4U Technologies",
    selectedCount: 4,
  },
  {
    id: 46,
    hallTicket: "23RU1A0528",
    studentName: "Eerla Nagavennala",
    department: "University College of Engineering",
    date: "",
    company: "",
    selectedCount: null,
  },
  {
    id: 47,
    hallTicket: "23RU1A0580",
    studentName: "Pujari Lakshmi Lokesh",
    department: "University College of Engineering",
    date: "",
    company: "",
    selectedCount: null,
  },
  {
    id: 48,
    hallTicket: "24RU5A0306",
    studentName: "Surya Sai Charan Rao",
    department: "University College of Engineering",
    date: "",
    company: "",
    selectedCount: null,
  },
  
{
  id: 49,
  hallTicket: "24RU5A0507",
  studentName: "SAI NIKITHA KAPU",
  department: "CSE",
  date: "07-10-2026",
  company: "TAP Academy",
},
{
  id: 50,
  hallTicket: "23RU1A0516",
  studentName: "BOGYAM PRAVEEN KUMAR",
  department: "ECE",
  date: "07-10-2026",
  company: "TAP Academy",
},
{
  id: 51,
  hallTicket: "23RU1A0527",
  studentName: "DUDEKULA EERLA",
  department: "EEE",
  date: "07-10-2026",
  company: "TAP Academy",
},
{
  id: 52,
  hallTicket: "23RU1A05A6",
  studentName: "YADAMALA HEMALATHA",
  department: "ME",
  date: "07-10-2026",
  company: "TAP Academy",
},
{
  id: 53,
  hallTicket: "23RU1A0583",
  studentName: "SHAIK AFRID",
  department: "CIVIL",
  date: "07-10-2026",
  company: "TAP Academy",
},
{
  id: 54,
  hallTicket: "23RU1A05A6",
  studentName: "YADAMALA HEMALATHA",
  department: "ME",
  date: "07-10-2026",
  company: "TAP Academy",
},
{
  id: 55,
  hallTicket: "24RU5A0606",
  studentName: "SHAIK ZABIULLA",
  department: "CSE",
  date: "07-10-2026",
  company: "TAP Academy",
},
{
  id: 56,
  hallTicket: "23RU1A0607",
  studentName: "KINDINTI SHIVA SHANKAR REDDY",
  department: "ECE",
  date: "07-10-2026",
  company: "TAP Academy",
},
{
  id: 57,
  hallTicket: "3RU1A0586",
  studentName: "SHAIK CARPENTER MOHAMMED REHAN",
  department: "CSE",
  date: "07-10-2026",
  company: "TAP Academy",
},
{
  id: 58,
  hallTicket: "23RU1A0614",
  studentName: "HARINIVAS MANDLA",
  department: "EEE",
  date: "07-10-2026",
  company: "TAP Academy",
},
{
  id: 59,
  hallTicket: "25905916025",
  studentName: "DASARI SAI YAMUNA SREE",
  department: "IT",
  date: "07-10-2026",
  company: "TAP Academy",
},

];

export const trainingActivities = [
  {
    id: 1,
    startDate: "07-08-2026",
    endDate: "11-09-2026",
    duration: "4 Weeks",
    organization: "Sri Lakshmi IT School Private Limited (SLITS)",
    targetStudents: "V Semester Students",
  },
  {
    id: 2,
    startDate: "07-08-2026",
    endDate: "11-09-2026",
    duration: "4 Weeks",
    organization: "Sri Lakshmi IT School Private Limited (SLITS)",
    targetStudents: "VII Semester Students",
  },
  {
    id: 3,
    startDate: "10-08-2026",
    endDate: "14-08-2026",
    duration: "5 Days",
    organization:
      "Magic Bus India Foundation, an IBM SkillsBuild Participant Organization, in collaboration with IBM SkillsBuild",
    targetStudents: "V Semester Students",
  },
  {
    id: 4,
    startDate: "17-08-2026",
    endDate: "20-08-2026",
    duration: "4 Days",
    organization:
      "Magic Bus India Foundation, an IBM SkillsBuild Participant Organization, in collaboration with IBM SkillsBuild",
    targetStudents: "III Semester Students & 2026 Batch Passed out",
  },
];
